// get_notifications
export const GET_NOTIFICATIONS = 'get_notifications';
export const GET_NOTIFICATIONS_SUCCESSFUL = 'get_notifications_successfull';
export const GET_NOTIFICATIONS_FAILED = 'get_notifications_failed';
export const UPDATE_NOTIFICATION_STATE = 'update_notification_state';

// remove_notification
export const REMOVE_NOTIFICATION = 'remove_notification';
export const REMOVE_NOTIFICATION_SUCCESSFUL = 'remove_notification_successfull';
export const REMOVE_NOTIFICATION_FAILED = 'remove_notification_failed';

// update_notification_seen_status
export const UPDATE_NOTIFICATION_SEEN_STATUS =
  'update_notification_seen_status';
export const UPDATE_NOTIFICATION_SEEN_STATUS_SUCCESSFUL =
  'update_notification_seen_status_successfull';
export const UPDATE_NOTIFICATION_SEEN_STATUS_FAILED =
  'update_notification_seen_status_failed';

// notification_delete_all
export const NOTIFICATION_DELETE_ALL = 'notification_delete_all';
export const NOTIFICATION_DELETE_ALL_SUCCESSFUL =
  'notification_delete_all_successfull';
export const NOTIFICATION_DELETE_ALL_FAILED = 'notification_delete_all_failed';

// notification_mark_all_read
export const NOTIFICATION_MARK_ALL_READ = 'notification_mark_all_read';
export const NOTIFICATION_MARK_ALL_READ_SUCCESSFUL =
  'notification_mark_all_read_successfull';
export const NOTIFICATION_MARK_ALL_READ_FAILED =
  'notification_mark_all_read_failed';
